export const CRM_TAGS_SETTINGS = 'crmTagsSettings';